import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

export const DEFAULT_LANG = 'sr';

/** Poznati jezički kodovi — ista lista kao u enduserCore-u (UserApp, kiosk). Svaki app ima
 *  svoj podskup prevoda; za ono što nema, ngx-translate pada na podrazumevani jezik. */
const SUPPORTED_LANGS = ['sr', 'en', 'hr', 'it', 'me', 'ro', 'ru', 'tr', 'zh', 'de'];

/**
 * Jezik prosleđen kroz URL (`?lang=en`).
 *
 * Aplikacije su na odvojenim poddomenima (app./konobar./kd./orders….), pa ne dele
 * localStorage — bez ovoga bi app otvoren iz admin portala uvek krenuo na svom, ranije
 * zapamćenom jeziku. Portal zato u link ubaci svoj aktivan jezik. Isti dogovor već postoji
 * u enduserCore (UserApp, kiosk).
 */
function languageFromUrl(): string | null {
  try {
    const lang = new URL(window.location.href).searchParams.get('lang')?.toLowerCase();
    return lang && SUPPORTED_LANGS.indexOf(lang) >= 0 ? lang : null;
  } catch {
    return null;
  }
}

@Injectable({
  providedIn: 'root'
})
export class LanguageService {


  currentLanguage = new BehaviorSubject<string>('');

  constructor(

  ) {

    // Prioritet: ?lang= iz URL-a → raniji izbor korisnika → podrazumevani jezik.
    var lang = languageFromUrl() || localStorage.getItem("language") || DEFAULT_LANG;


    this.setLanguage(lang);
  }

  setPerferredLanguage(lang: string) {
    if (!lang) {
      return;
    }

  }

  setLanguage(lang: string) {
    if (this.currentLanguage.value == lang) {
      return;
    }

    localStorage.setItem("language", lang);
    this.currentLanguage.next(lang);

  }
}
